import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ChatMainComponent } from './chat-main/chat-main.component';
import { ChatHistoryComponent } from './chat-history/chat-history.component';
import { ChatMessageComponent } from './chat-message/chat-message.component';
import { TransactionDetailsComponent } from './transaction-details/transaction-details.component';
import { ChatAuthComponent } from './chat-auth/chat-auth.component';
import { PromptsComponent } from './prompts/prompts.component';

@NgModule({
  declarations: [
    ChatMainComponent,
    ChatHistoryComponent,
    ChatMessageComponent,
    TransactionDetailsComponent,
    ChatAuthComponent,
    PromptsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule
  ]
})
export class ChatModule { }
